import S3 from "react-aws-s3";
import { toast } from "react-toastify";
import { makeid_alpa_numeric } from "./utils";
import { useState } from "react";
import { Buffer } from "buffer";

// Polyfill Buffer for Vite
if (typeof window !== 'undefined' && !window.Buffer) {
  window.Buffer = Buffer;
}
// const sharedSecretResponse = await apiSauce.apisauce.post("utils/get-shared-secret")
//         const cloudUploadDownloadCredsResponse = await apiSauce.apisauce.post(
//           "utils/get-cloud-upload-download-creds",
//         )
//         const secret = await sharedSecretResponse?.data?.["secret"]
//         const nonce = await cloudUploadDownloadCredsResponse?.data?.["nonce"]
//         const ciphertext = await cloudUploadDownloadCredsResponse?.data?.["ciphertext"]
//         const s3CredentialsResponse = await apiSauce.apisauce.post(
//           "utils/get-raw-unsecure-cloud-upload-download-creds",
//           {
//             secret,
//           },
//         )
const decrypt_cloud_secrets = async () => {
  const sharedSecret = localStorage.getItem("secret");

  const payload = {
    nonce: localStorage.getItem("nonce"),
    ciphertext: localStorage.getItem("ciphertext"),
  };

  function base64ToBytes(b64: string) {
    return Uint8Array.from(atob(b64), (c) => c.charCodeAt(0));
  }

  const enc = new TextEncoder();
  let secretBytes = enc.encode(sharedSecret!);

  let salt;
  if (secretBytes.length >= 32) {
    salt = secretBytes.slice(secretBytes.length - 32);
  } else {
    const hash = await crypto.subtle.digest("SHA-256", secretBytes);
    salt = new Uint8Array(hash);
  }

  const passwordKey = await crypto.subtle.importKey(
    "raw",
    secretBytes,
    "PBKDF2",
    false,
    ["deriveKey"],
  );

  const aesKey = await crypto.subtle.deriveKey(
    {
      name: "PBKDF2",
      salt: salt,
      iterations: 100000,
      hash: "SHA-256",
    },
    passwordKey,
    { name: "AES-GCM", length: 256 },
    false,
    ["decrypt"],
  );

  const iv = base64ToBytes(payload.nonce!);
  const ciphertext = base64ToBytes(payload.ciphertext!);

  try {
    const decrypted = await crypto.subtle.decrypt(
      { name: "AES-GCM", iv: iv },
      aesKey,
      ciphertext,
    );
    const decoder = new TextDecoder();
    return JSON.parse(decoder.decode(decrypted));
  } catch (e) {
    console.error("Decryption failed:", e);
  }
};

export const error_toast = () => {
  return toast.error("something went wrong, please try again later");
};

const getFileExtension = (filename) => {
  return filename.split(".").pop();
};

const getFileName = (filename) => {
  const name = filename.split(".");
  return name[0];
};

// const getFileName = (filename) => {
//   const name = filename.split(".");
//   console.log(name);

//   return name[0].includes("WhatsApp")
//     ? name[0].replace("WhatsApp", "")
//     : name[0];
// };

let S3REGION = "ap-south-1";
let S3ACCESSKEYID;
let S3SECRETACCESSKEY;

async function getS3() {
  try {
    S3ACCESSKEYID = localStorage.getItem("S3_ACCESSKEY");
    S3SECRETACCESSKEY = localStorage.getItem("S3_SECRETKEY");
    // console.log("S3_ACCESS", S3ACCESSKEYID);
    // console.log("S3_SECRET", S3SECRETACCESSKEY);
    // const res = await decrypt_cloud_secrets();

    if (S3ACCESSKEYID && S3SECRETACCESSKEY) {
      return {
        region: "ap-south-1",
        accessKeyId: S3ACCESSKEYID,
        secretAccessKey: S3SECRETACCESSKEY,
      };
    } else {
      throw new Error("Invalid credentials object received from decryption");
    }
  } catch (e) {
    console.error("Failed to get S3 creds", e);
  }
}

//TODO: It will support multiple file uploads for one event
export const useFileUpload = () => {
  const [isUploading, setIsUploading] = useState(false);
  // const id = makeid_alpa_numeric(6);
  const uploadFileToS3 = async (path, file, bucket = "urn-assets") => {
    const id = makeid_alpa_numeric(6);

    try {
      // await getS3();
      setIsUploading(true);
      const s3Creds = await getS3();
      const s3config = {
        bucketName: bucket,
        dirName: path,
        region: s3Creds.region,
        accessKeyId: s3Creds.accessKeyId,
        secretAccessKey: s3Creds.secretAccessKey,
      };
      // @ts-ignore
      const ReactS3Client = new S3(s3config);
      const extension = getFileExtension(file.name);
      const newFileName = getFileName(file.name) + "_" + id + "." + extension;
      let res = undefined;
      await ReactS3Client.uploadFile(file, newFileName)
        .then((data) => {
          toast.success("File uploaded successfully..");
          res = data;
        })
        .catch((err) => {
          console.log("Failed", err);
        })
        .finally(() => {
          setIsUploading(false);
        });
      return res;
    } catch (e) {
      toast.error("Something went wrong..");
      setIsUploading(false);
    }
  };
  return { isUploading, uploadFileToS3 };
};

export const uploadFile = async (path, file, bucket = "urn-assets") => {
  try {
    const creds = await getS3();

    const s3config = {
      bucketName: bucket,
      dirName: path,
      region: creds.region,
      accessKeyId: creds.accessKeyId,
      secretAccessKey: creds.secretAccessKey,
    };

    // @ts-ignore
    const ReactS3Client = new S3(s3config);
    const id = makeid_alpa_numeric(6);

    const extension = getFileExtension(file.file.name);
    const newFileName =
      getFileName(file.file.name) + "_" + id + "." + extension;

    const res = await ReactS3Client.uploadFile(file.file, newFileName);
    toast.success("File uploaded successfully..");

    return s3config.dirName + "/" + newFileName;
  } catch (e) {
    toast.error("Something went wrong..");
    console.log("error", e);
    return null;
  }
};

export const upload_file = async (path, file, bucket = "urn-assets") => {
  const s3config = {
    bucketName: bucket,
    dirName: path,
    region: S3REGION,
    accessKeyId: S3ACCESSKEYID,
    secretAccessKey: S3SECRETACCESSKEY,
  };

  try {
    const ReactS3Client = new S3(s3config);
    const extension = getFileExtension(file.name);
    const newFileName = getFileName(file.name) + "." + extension;
    const response = await ReactS3Client.uploadFile(file, newFileName).then(
      (data) => {
        console.log("file uploaded data", data);
      },
    );
    if (response.status === 200) {
      return response;
    } else {
      error_toast();
      return {};
    }
  } catch (e) {
    error_toast();
    console.log("error", e);
  }
};

export const uploadBlob = async (
  pathdir,
  filename,
  blob,
  bucket = "urn-assets",
) => {
  try {
    const creds = await getS3();

    const s3config = {
      bucketName: bucket,
      dirName: pathdir,
      region: creds.region,
      accessKeyId: creds.accessKeyId,
      secretAccessKey: creds.secretAccessKey,
    };

    // @ts-ignore
    const ReactS3Client = new S3(s3config);
    const result = await ReactS3Client.uploadFile(blob, filename);

    return result;
  } catch (e) {
    toast.error("Something went wrong..");
    console.log("error", e);
    return null;
  }
};
